import styles from './RequiredAsterisk.module.scss'
import React from 'react'
export const RequiredAsterisk: React.FC<unknown> = () => {
    return <div className={styles.requiredAsterisk}>*</div>
}
